/**
 * PlanIndicator API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { CreatePlanIndicatorRequestDto } from '../model/create-plan-indicator-request';
// @ts-ignore
import { CreatePlanIndicatorResponseDto } from '../model/create-plan-indicator-response';
// @ts-ignore
import { ErrorResponseDto } from '../model/error-response';
// @ts-ignore
import { IndicatorResponseDto } from '../model/indicator-response';
// @ts-ignore
import { PlanIdsBatchRequestDto } from '../model/plan-ids-batch-request';
// @ts-ignore
import { PlanIndicatorFindByPlanIdLightResponseDto } from '../model/plan-indicator-find-by-plan-id-light-response';
// @ts-ignore
import { PlanIndicatorFindByPlanIdResponseDto } from '../model/plan-indicator-find-by-plan-id-response';
// @ts-ignore
import { PlanIndicatorGroupedResponseDto } from '../model/plan-indicator-grouped-response';
// @ts-ignore
import { PlanIndicatorListAllLightResponseDto } from '../model/plan-indicator-list-all-light-response';
// @ts-ignore
import { PlanIndicatorResponseDto } from '../model/plan-indicator-response';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    PlanIndicatorServiceInterface,
    CreateRequestParams,
    DeleteByIdRequestParams,
    FindByIdRequestParams,
    FindByPlanIdRequestParams,
    FindByPlanIdGroupedRequestParams,
    FindByPlanIdLightRequestParams,
    FindByPlanIdsBatchGroupedRequestParams
} from './plan-indicator.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class PlanIndicatorService extends BaseService implements PlanIndicatorServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Create a new planIndicator
     * @endpoint post /v1/plan/{planId}/plan-indicator
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public create(requestParameters: CreateRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<CreatePlanIndicatorResponseDto>;
    public create(requestParameters: CreateRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<CreatePlanIndicatorResponseDto>>;
    public create(requestParameters: CreateRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<CreatePlanIndicatorResponseDto>>;
    public create(requestParameters: CreateRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const planId = requestParameters?.planId;
        if (planId === null || planId === undefined) {
            throw new Error('Required parameter planId was null or undefined when calling create.');
        }
        const createPlanIndicatorRequestDto = requestParameters?.createPlanIndicatorRequestDto;
        if (createPlanIndicatorRequestDto === null || createPlanIndicatorRequestDto === undefined) {
            throw new Error('Required parameter createPlanIndicatorRequestDto was null or undefined when calling create.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (OidcBearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('OidcBearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/v1/plan/${this.configuration.encodeParam({name: "planId", value: planId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/plan-indicator`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<CreatePlanIndicatorResponseDto>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: createPlanIndicatorRequestDto,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete a planIndicator by its identifier
     * @endpoint delete /v1/plan/{planId}/plan-indicator/{id}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public deleteById(requestParameters: DeleteByIdRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<any>;
    public deleteById(requestParameters: DeleteByIdRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<HttpResponse<any>>;
    public deleteById(requestParameters: DeleteByIdRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<HttpEvent<any>>;
    public deleteById(requestParameters: DeleteByIdRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<any> {
        const planId = requestParameters?.planId;
        if (planId === null || planId === undefined) {
            throw new Error('Required parameter planId was null or undefined when calling deleteById.');
        }
        const id = requestParameters?.id;
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteById.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (OidcBearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('OidcBearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/v1/plan/${this.configuration.encodeParam({name: "planId", value: planId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/plan-indicator/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('delete', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Find all active planIndicators (Light version)
     * @endpoint get /v1/plan-indicators/all-light
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public findAllLight(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<PlanIndicatorListAllLightResponseDto>;
    public findAllLight(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<PlanIndicatorListAllLightResponseDto>>;
    public findAllLight(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<PlanIndicatorListAllLightResponseDto>>;
    public findAllLight(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        // authentication (OidcBearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('OidcBearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/v1/plan-indicators/all-light`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PlanIndicatorListAllLightResponseDto>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get a planIndicator by its identifier
     * @endpoint get /v1/plan/{planId}/plan-indicator/{id}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public findById(requestParameters: FindByIdRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<PlanIndicatorResponseDto>;
    public findById(requestParameters: FindByIdRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<PlanIndicatorResponseDto>>;
    public findById(requestParameters: FindByIdRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<PlanIndicatorResponseDto>>;
    public findById(requestParameters: FindByIdRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const planId = requestParameters?.planId;
        if (planId === null || planId === undefined) {
            throw new Error('Required parameter planId was null or undefined when calling findById.');
        }
        const id = requestParameters?.id;
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling findById.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (OidcBearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('OidcBearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/v1/plan/${this.configuration.encodeParam({name: "planId", value: planId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/plan-indicator/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PlanIndicatorResponseDto>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Find planIndicator by planId
     * @endpoint get /v1/plan/{planId}/plan-indicator/all
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public findByPlanId(requestParameters: FindByPlanIdRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<PlanIndicatorFindByPlanIdResponseDto>;
    public findByPlanId(requestParameters: FindByPlanIdRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<PlanIndicatorFindByPlanIdResponseDto>>;
    public findByPlanId(requestParameters: FindByPlanIdRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<PlanIndicatorFindByPlanIdResponseDto>>;
    public findByPlanId(requestParameters: FindByPlanIdRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const planId = requestParameters?.planId;
        if (planId === null || planId === undefined) {
            throw new Error('Required parameter planId was null or undefined when calling findByPlanId.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (OidcBearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('OidcBearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/v1/plan/${this.configuration.encodeParam({name: "planId", value: planId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/plan-indicator/all`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PlanIndicatorFindByPlanIdResponseDto>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Find planIndicator by planId grouped by parent indicator
     * @endpoint get /v1/plan/{planId}/plan-indicator/all-grouped
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public findByPlanIdGrouped(requestParameters: FindByPlanIdGroupedRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<PlanIndicatorGroupedResponseDto>;
    public findByPlanIdGrouped(requestParameters: FindByPlanIdGroupedRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<PlanIndicatorGroupedResponseDto>>;
    public findByPlanIdGrouped(requestParameters: FindByPlanIdGroupedRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<PlanIndicatorGroupedResponseDto>>;
    public findByPlanIdGrouped(requestParameters: FindByPlanIdGroupedRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const planId = requestParameters?.planId;
        if (planId === null || planId === undefined) {
            throw new Error('Required parameter planId was null or undefined when calling findByPlanIdGrouped.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (OidcBearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('OidcBearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/v1/plan/${this.configuration.encodeParam({name: "planId", value: planId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/plan-indicator/all-grouped`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PlanIndicatorGroupedResponseDto>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Find planIndicator by planId (Light version)
     * @endpoint get /v1/plan/{planId}/plan-indicator/all/light
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public findByPlanIdLight(requestParameters: FindByPlanIdLightRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<PlanIndicatorFindByPlanIdLightResponseDto>;
    public findByPlanIdLight(requestParameters: FindByPlanIdLightRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<PlanIndicatorFindByPlanIdLightResponseDto>>;
    public findByPlanIdLight(requestParameters: FindByPlanIdLightRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<PlanIndicatorFindByPlanIdLightResponseDto>>;
    public findByPlanIdLight(requestParameters: FindByPlanIdLightRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const planId = requestParameters?.planId;
        if (planId === null || planId === undefined) {
            throw new Error('Required parameter planId was null or undefined when calling findByPlanIdLight.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (OidcBearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('OidcBearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/v1/plan/${this.configuration.encodeParam({name: "planId", value: planId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/plan-indicator/all/light`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PlanIndicatorFindByPlanIdLightResponseDto>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Find plan indicators grouped by planId in batch
     * @endpoint post /v1/plan-indicators/batch-grouped
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public findByPlanIdsBatchGrouped(requestParameters: FindByPlanIdsBatchGroupedRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<{ [key: string]: Array<IndicatorResponseDto>; }>;
    public findByPlanIdsBatchGrouped(requestParameters: FindByPlanIdsBatchGroupedRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<{ [key: string]: Array<IndicatorResponseDto>; }>>;
    public findByPlanIdsBatchGrouped(requestParameters: FindByPlanIdsBatchGroupedRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<{ [key: string]: Array<IndicatorResponseDto>; }>>;
    public findByPlanIdsBatchGrouped(requestParameters: FindByPlanIdsBatchGroupedRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const planIdsBatchRequestDto = requestParameters?.planIdsBatchRequestDto;
        if (planIdsBatchRequestDto === null || planIdsBatchRequestDto === undefined) {
            throw new Error('Required parameter planIdsBatchRequestDto was null or undefined when calling findByPlanIdsBatchGrouped.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (OidcBearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('OidcBearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/v1/plan-indicators/batch-grouped`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<{ [key: string]: Array<IndicatorResponseDto>; }>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: planIdsBatchRequestDto,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
